const theme = {
	palette: {
		primary: {
			main: '#fc544c',
		},
		secondary: {
			main: '#4d2cd1',
		},
	},
	typography: {
		fontFamily: '"Open Sans", sans-serif',
		h1: {
			fontFamily: '"Poppins", sans-serif',
			fontWeight: 600,
			fontSize: '2.5rem',
		},
		h2: {
			fontFamily: '"Poppins", sans-serif',
			fontWeight: 600,
			fontSize: '2rem',
		},
		h3: {
			fontFamily: '"Poppins", sans-serif',
			fontWeight: 600,
			fontSize: '1.75rem',
		},
	},
};

export default theme;
